<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-3">
    <form class="login-formx form-validate" action="index.html" onsubmit="return false" id="inviteUserForm">
      <div class="row">
        <div class="col-12">
          <div class="form-group row mt-0">
            <div class="col-lg-12 custom-form-main-label">
              <span v-if="hasEmail == true">{{$t('invite_user')}}</span>
              <span v-if="hasEmail != true">{{$t('create_user')}}</span>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('username_or_email')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <input @input="checkUserNameOrEmail" required maxlength="100" v-model="username" type="text" class="form-control" v-bind:placeholder="$t('username_or_email')" name="username" id="username">
            </div>
          </div>
          <div v-for="(email,index) in emails" class="form-group row mt-1">
            <div class="col-10">
              <input v-model="email.email" v-bind:placeholder="$t('enter_email')" type="email" class="form-control" name="email" v-bind:id="'txt_email_' +  getId()">
            </div>
            <div class="col-2"><a href="#" @click="deleteEmail(index)" style="color: inherit;"><i style="font-size: 20px; color: inherit; margin-top: 8px" class="fa fa-trash-o"></i></a></div>
          </div>
          <div class="row mt-3" v-show="hasEmail == true">
            <div class="col-12">
              <a href="#" @click="addEmailControl" style="color: inherit">+ {{$t('add_another')}}</a>
            </div>
          </div>
          <!--<div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('email')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">-->
          <!--<input required v-model="email" type="text" class="form-control" @change="checkForComma" v-bind:placeholder="$t('email')" name="email" id="email">-->
          <!--<input @change="checkUserNameOrEmail" v-model="email" maxlength="100" type="text" class="form-control" v-bind:placeholder="$t('email')" name="email" id="email">
            </div>
          </div>-->
          <!--<div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('name')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <input v-model="fullname" type="text" class="form-control" v-bind:placeholder="$t('name')" name="fullname" id="fullname">
            </div>
          </div>-->
          <!--<div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('permission_level')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <select required class="form-control" v-bind:id="'select_assigned_group_' +  getId()">
                <option value="" style="">{{$t('select_permission_level')}}</option>
                <option v-for="group in groups" v-bind:value="group">
                  {{ group }}
                </option>
              </select>
            </div>
          </div>-->
          <!--<div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('team')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <team-select-selector style="width:100%" ref="teamSelectorRef" @event-change-team="onChangeTeam"></team-select-selector>
            </div>
          </div>-->
          <div class="row mt-3" v-show="hasEmail == true">
            <div class="col-lg-12 custom-form-label">
              {{$t('message')}}
            </div>
          </div>
          <div class="form-group row mt-1" v-show="hasEmail == true">
            <div class="col-lg-12">
              <textarea rows="3" cols="3" @change="content_change" class="form-control" v-model="email_content" v-bind:placeholder="$t('empty_invitation_mail')"></textarea>
            </div>
          </div>
          <div class="form-group row mt-1" v-show="hasEmail == false">
            <div class="col-lg-12">
              <input-checkbox @input="setOverride" v-bind:value="1" v-bind:id="'chk_' +  getId()"
                              v-bind:name="'chk_' +  getId()" v-bind:checked="isPasswordSet"
                              v-bind:text="$store.translate('set_password')" class="mt-1"></input-checkbox>
            </div>
          </div>


          <div class="row mt-3" v-if="isPasswordSet == true && hasEmail == false">
            <div class="col-lg-12 custom-form-label">
              {{$t('password')}}
            </div>
          </div>
          <div class="form-group row mt-1" v-if="isPasswordSet == true && hasEmail == false">
            <div class="col-lg-12">
              <input required v-model="password" type="password" class="form-control" v-bind:placeholder="$t('password')" name="password" id="password">
            </div>
          </div>
          <div class="row mt-3" v-if="isPasswordSet == true && hasEmail == false">
            <div class="col-lg-12 custom-form-label">
              {{$t('confirm_password')}}
            </div>
          </div>
          <div class="form-group row mt-1" v-if="isPasswordSet == true && hasEmail == false">
            <div class="col-lg-12">
              <input v-model="confirmpassword" type="password" class="form-control" v-bind:placeholder="$t('confirm_password')" name="confirmpassword" id="confirmpassword">
            </div>
          </div>
          <div class="form-group row mt-3">
            <div class="col-lg-12">
              <button v-if="hasEmail == true" @click="inviteUser" type="submit" class="btn skin primary-button pull-right">{{$t('invite_user')}}</button>
              <button v-if="hasEmail == false" @click="inviteUser" type="submit" class="btn skin primary-button pull-right">{{$t('create')}}</button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div v-if="message != null && message != ''" class="col-12 alert alert-light upload-error-message" role="alert">
      <ul>
        <li class="col-12" v-for="(ms, i) in message.split('\n')" :key="i">
          {{ ms }}
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
  import TeamRegisterInvite from "../team/team-registration-invite.vue";
  import TeamSelector from '../team/team-select-selector'
  var isPasswordSet = false;
  let message = "";
  var groups = [];
  var placeholder = "";
  var email_content = "";
  var fullname = "";
  var confirmpassword = "";
  var password = "";
  export default {
    name: "invite-user",
    components: {
      TeamSelector,
    },
    props: {

    },
    data() {
      return {
        placeholder,
        message: "",
        email: '',
        groups,
        email_content,
        fullname,
        username: '',
        teamId: -1,
        isPasswordSet: false,
        confirmpassword: '',
        password: '',
        hasEmail: false,
        emails: [],
        group: '',
      };
    },
    methods: {
      addEmailControl() {
        this.emails.push({ id: this.index, email: '' });
        this.index++;
        Vue.set(this, "emails", this.emails)
        this.$forceUpdate();
      },
      deleteEmail(index) {
        this.emails.splice(index, 1);
        console.log(this.emails);
        Vue.set(this, "emails", this.emails);
        this.$forceUpdate();
      },
      checkUserNameOrEmail() {
        if (this.email.indexOf('@') > -1 || this.username.indexOf('@') > 0) {
          this.hasEmail = true;
        }
        else {
          this.emails = [];
          this.hasEmail = false;
        }
      },
      openInvite() {
        //if (this.hasEmail == false)
        //  return;
        this.$refs.teamRegsitrationInviteSelector.open(this.teamId);
      },
      setOverride(checked, val, value) {
        this.isPasswordSet = checked;
      },
      content_change() {
        if (this.email_content == '') {
          this.email_content = this.$t('invitation_mail_content');
        }
      },


      clearFields() {
        this.emails = [];
        this.username = '';
        this.email = '';
        this.fullname = '';
        this.password = '';
        this.isPasswordSet = false;
        this.confirmpassword = '';
        this.hasEmail = false;
      },
      getId() {
        return this._uid;
      },
      async inviteUser() {
        if (!$('#inviteUserForm').valid())
          return false;
        var pass = null;
        if (this.isPasswordSet)
          pass = this.password;

        if (this.email !== null && this.email !== undefined) {
          this.email = this.email.trim();
        }
        if (this.fullname !== null && this.fullname !== undefined) {
          this.fullname = this.fullname.trim();
        }
        if (this.username !== null && this.username !== undefined) {
          this.username = this.username.trim();
        }

        var mails = [];
        if (this.hasEmail) {          
          mails.push(this.username);
          this.username = '';
          this.emails.forEach((item, index) => {
            mails.push(item.email);
          });
        }
        var request = {
          emails: mails, email_content: this.email_content,
          username: this.username, password: pass, group: this.group
        };
        try {
          var response = await this.$http.post(
            '/api/Users/v1/InviteAndCreate',
            request
          ).then(async response => {
            this.clearFields();
            vm.$root.$emit('refreshview');
          });

        } catch (err) {
          alert(err);
        }
      },
      loadGroupsOnDemand(group) {
        this.group = group;
        //this.loadGroups(group);
        this.loadSiteEmailConetent();
      },
      loadSiteEmailConetent() {
        try {
          var url = "/api/Sites/v1/EmailContent";
          this.$http.get(url).then(async response => {
            var data = response.data;
            if (data.emailContent !== null && data.emailContent !== '')
              this.email_content = data.emailContent;
            this.$forceUpdate();
          });
        }
        catch (err) {
          alert('some error:' + err)
        }
      },
      loadGroups(group) {
        try {
          var rootContentId = $('#hiddenRootContentId').val();
          var url = "/api/Site/GetAllGroups?rootContentId=" + rootContentId + '&groupLoad=' + group;
          this.$http.get(url).then(async response => {
            this.groups = response.data;
            $('#select_assigned_group_' + this.getId()).select2();
            this.$forceUpdate();
          });
        }
        catch (err) {
          alert('some error:' + err)
        }
      }
    },
    watch: {
    },
    mounted() {

      
      var rules = {
        'username': {
          //required: true,
          usernamechk: true,
          minlength: 6,

        },
        'email': {
          required: false,
          email: true
        },
        'password': {
          required: true,
          pwcheck: true,
          minlength: 8,

        },
        'confirmpassword': {
          required: true,
          equalTo: '#password'
        }
      };
      $.validator.addMethod("pwcheck", function (value) {
        //var patt = new RegExp("e");
        var regex = /^.{8,}$////^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/
        return regex.test(value);
      });
      $.validator.addMethod("usernamechk", function (value) {
        //var patt = new RegExp("e");
        var regex = /^\S+$/
        return regex.test(value);
      });
      var messages = {
        'username': {
          //required: 'Required',
          usernamechk: 'Username must be at least 6 characters without space.',
          minlength: 'Username must be at least 6 characters long.'
        },
        'password': {
          required: 'Required',
          pwcheck: 'Password must be at least 8 characters long.',
          minlength: 'Password must be at least 8 characters long.'
        },

        'confirmpassword': {
          required: 'Required',
          minlength: 'Password must be at least 8 characters long.',
          equalTo: 'Please enter the same password as above.'
        }
      };

      _componentValidation('#inviteUserForm', rules, messages);
      //this.loadGroups('');
      this.email_content = this.$t('invitation_mail_content');
      //this.loadSiteEmailConetent();
    }
  };
</script>

<style scoped>
  .select_container {
    width: calc(100%)
  }
</style>




// WEBPACK FOOTER //
// src/components/user/invite-user.vue